import { ApiService } from './api.service';
import { STATUS_DRAFT, STATUS_CONSIDERING } from '../config/consts';
import i18n from '../i18n';

const DocumentService = {
    async getDocumentFormByDocumentId(documentId) {
        return (await ApiService.get('v1/documents/form/' + documentId)).data;
    },
    /**
     * Возвращает данные эцп по  конкретной заявке
     **/
    async getDocumentEDS(documentId) {
        return (await ApiService.get('v1/documents/' + documentId + '/eds')).data;
    },
    /**
     * Возвращает ФИО, ИИН с эцп
     * @param {*} data Данные заявки
     */
    async getEdsInfo(data) {
        try {
            let response = await ApiService.post(`v1/documents/eds/info`, data);
            return response.data;
        } catch (e) {
            throw e;
        }
    },
    /**
     * Удаление заявки
     * @param {*} documentId id Заявки
     */
    async deleteDocument(documentId) {
        try {
            let response = await ApiService.delete(`v1/documents/${documentId}`);
            return response.data;
        } catch (e) {
            throw e;
        }
    },
    /**
     * Возвращает дерево конкретной папки
     **/
    getDocumentsTableAll: async function (folderId, status, requestType, roesName, dateFrom, dateTo, page, size, sortBy, descending) {
        let sort =
            sortBy == null
                ? status === STATUS_DRAFT
                    ? 'data.mainData.createDateTime,desc'
                    : 'data.mainData.requestNumber,desc'
                : 'data.mainData.' + sortBy + ',' + (descending ? 'desc' : 'asc');

        if (sortBy === "roesName") {
            if ((status === STATUS_DRAFT) || (status === STATUS_CONSIDERING)) {
                const locale = i18n.locale === "kz" ? "Kk" : "Ru"
                sort = `data.accountsData.roes_name___${locale},${descending ? 'desc' : 'asc'}`
            } else {
                sort = 'data.accountsData.roes_name' + ',' + (descending ? 'desc' : 'asc')
            }
        } else if (sortBy === "accountNumber") {
            sort = 'data.accountsData.account_number' + ',' + (descending ? 'desc' : 'asc')
        }

        let requestData = {
            method: 'get',
            url: `v1/documents/all/table/${folderId}`,
            params: {
                status: status,
                page: page,
                size: size,
                sort: sort,
                requestType,
                roesName,
                dateFrom: dateFrom || '',
                dateTo: dateTo || ''
            },
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        };
        try {
            //console.log("Options: ", requestData)
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    downloadFile: async function (fileId) {
        try {
            return (await ApiService.get(`v1/document-files/download/` + fileId, { responseType: 'blob' })).data;
        } catch (e) {
            console.log(e);
        }
    },
    /**
     * Возвращает сгенерированный документ акцепт заявки
     * @param {*} lang Язык файла (rus || kaz)
     * @param {*} data Файлы акцепта
     */
    acceptRequestDoc: async function(lang, data) {
        try {
            let response = await ApiService.post(`v1/document-files/accept/` + lang, data);
            return response.data;
        } catch (e) {
            throw e;
        }
    },
    uploadFile: async function (fileData, fileName) {
        try {
            let response = await ApiService.post(`v1/document-files` + '?name=' + fileName, fileData, {
                headers: {
                    'Content-Type': 'application/octet-stream'
                }
            });
            return response.data.id; //id загруженного файла
        } catch (error) {
            throw error;
        }
    },
    getDocumentFoldersTreeById: async function (folderId) {
        try {
            let response = await ApiService.get(`v1/document-folders/tree/${folderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDocumentFoldersTreeById2: async function (folderId) {
        try {
            let response = await ApiService.get(`v1/document-folders/tree2/${folderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDivisions: async function () {
        try {
            let response = await ApiService.get(`v1/process/task/getDivisions`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает сгруппированное по статусу кол-во заявок доступных пользователю
     * @param {*} userId ID-пользователя
     */
    getGrouppedDocCounts: async function (userId) {
        try {
            let response = await ApiService.get(`v1/documents/count/${userId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDocumentById: async function (id) {
        try {
            let response = await ApiService.get(`v1/documents/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDocumentFoldersTree: async function () {
        try {
            let response = await ApiService.get('v1/document-folders/tree');
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает описание папки
     **/
    getDocumentFoldersById: async function (folderId) {
        try {
            let response = await ApiService.get(`v1/document-folders/${folderId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDocumentsTable: async function (id, page, size, sortBy, descending) {
        let sort = sortBy == null ? 'id,asc' : 'data.' + sortBy + ',' + (descending ? 'desc' : 'asc');

        let requestData = {
            method: 'get',
            url: `v1/documents/table/${id}`,
            params: {
                page: page,
                size: size,
                sort: sort
            }
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    postDocuments: async function (documentData) {
        try {
            let response = await ApiService.post(`v1/documents`, documentData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getDocumentFoldersParentById: async function (id, page, size, sortBy, descending) {
        let sort = sortBy == null ? 'id,asc' : 'data.' + sortBy + ',' + (descending ? 'desc' : 'asc');

        let requestData = {
            method: 'get',
            url: `v1/document-folders/parent/${id}`,
            params: {
                page: page,
                size: size,
                sort: sort
            }
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    getUserDocumentFolders: async function () {
        try {
            let response = await ApiService.get(`v1/document-folders/cuser`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    /**
     * Возвращает права доступа пользователю по документу.
     * @param {*} documentId - ID документа
     * Результат:
     * view_access - доступ на просмотр
     * execute_access - доступ на выполнение
     * {
     *     "view_access": true,
     *     "execute_access": true
     * }
     */
    getUserDocumentPermissions: async function (documentId) {
        let requestData = {
            method: 'get',
            url: `v1/documents/userdocper/${documentId}`
        };
        try {
            let response = await ApiService.customRequest(requestData);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default DocumentService;

export { DocumentService };
